import React, { useState, useEffect, useRef } from 'react';
import { FaLink } from 'react-icons/fa6';
import { LuArrowDownUp } from "react-icons/lu";
import { FaTrash } from "react-icons/fa6";
import tmLogo from '../assets/ticketmaster_log.png';
import EventFilterModal from '../components/EventFilterModal';
import { isValidate, PopulateEventData, GetAllUrls, ActivateEvents, DeleteEvents, fetchEventDetails, saveFilterDetails } from '../components/services/api';
import { useNavigate } from 'react-router-dom';
import usePagination from '../components/hooks/usePagination';
import Pagination from '../components/Pagination';
import { IoIosSearch } from 'react-icons/io';
import { BiColumns } from 'react-icons/bi';
import Guide from './Guide';
import ScreenLoading from '../components/ScreenLoading';

export default function Dashboard() {
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();
  const [urlInput, setUrlInput] = useState('');
  const [selectedEvent, setSelectedEvent] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [showModal, setShowModal] = useState(false);
  const handleHide = () => {
    setShowModal(false);
    resumeBackgroundProcessing();
  };
  const handleShow = () => setShowModal(true);
  const [hasFilter, setHasfilter] = useState();
  const [searchTerm, setSearchTerm] = useState('');
  const [UrlRange, setUrlRange] = useState('0-0');
  const [used, total] = UrlRange ? UrlRange.split('-') : [0, 0];
  const [showGuide, setShowGuide] = useState(false);

  const [message, setMessage] = useState('');
  const [selectEvent, setSelectEvent] = useState([]);
  // Resume processEventsInBackground after user closes/saves the empty-price filter modal
  const resumeBackgroundRef = useRef(null);

  const searchEvents = events.filter(event => !searchTerm ||
    (event.EventName && event.EventName.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  //table pagination
  const {
    currentPage,
    totalPages,
    currentData,
    goToPage,
    rowsPerPage,
    changeRowsPerPage
  } = usePagination(searchEvents, 10);

  const ranOnce = useRef(false);
  // useValidation();
  useEffect(() => {
    if (ranOnce.current) return;
    ranOnce.current = true;
    const guideShown = localStorage.getItem("dashboardGuide");
    if (!guideShown) {
      setShowGuide(true);
      localStorage.setItem("dashboardGuide", "true")
    }

    const checkValidation = async () => {
      try {
        const result = await isValidate();
        if (result.d === true) {
          await populateEventData();
          await fetchUrls();
        }
        else {
          if (result.d === false) {
            navigate("/");
          }
          else {
            navigate("/");
          }
        }
      }
      catch (error) {
        console.log('validation error');
        navigate("/");
      }
    };
    checkValidation();
  }, []);

  const fetchUrls = async () => {
    try {
      const url = await GetAllUrls();
      if (url && url.d) {
        setUrlRange(url.d);
      }
    } catch (error) {
      console.log('Error fetching URL range:', error);
    }
  }

  const populateEventData = async () => {
    try {
      const response = await PopulateEventData();
      if (response && response.d) {
        const formatedEvents = response.d.map((item) => ({
          EventName: item.eventName,
          EventVenue: item.eventVenue,
          EventDate: item.eventDate,
          EventLink: item.eventID,
          EventInfoID: item.eventInfoID,
          price: item.price ? item.price.split(",").map(Number) : [],
          ticketType: item.ticketType,
          section: item.section,
          active: item.active,
          hasFilter: true,

        }));
        // setEvents(formatedEvents);
        setEvents(prev => {
          const manualEvents = prev.filter(ev => ev.hasFilter === false); 
          return [...manualEvents, ...formatedEvents];
        });
        setLoading(false);
      }
    } catch (error) {
      console.log("Error fetching event data:", error);
    }
  }

  // use state for dynamic table data
  // const [row, setRows] = useState([
  //   {
  //     id: 1,
  //     eventName: "",
  //     eventVenue: "",
  //     eventDate: "",
  //   }
  // ]);

  const isValidUrl = (value) => {
    if (!value) return false;
    const lines = value.split(/\r?\n/).filter(line => line.trim() !== '');
    const result = lines.map((line) => {
      try {
        const url = new URL(line.trim());
        const isHttp = url.protocol === "http:" || url.protocol === "https:";
        const isTicketmaster = url.hostname.includes('ticketmaster') && url.pathname.toLowerCase().includes('/event/');
        return isHttp && isTicketmaster;
      } catch (err) {
        return false;
      }
    });
    return result.every(Boolean);
  }
  const handleAddUrl = () => {
    const urls = urlInput.split("\n").map(u => u.trim()).filter(url => url !== "" && isValidUrl(url));
    if (urls.length === 0) return;
    const newEvent = urls.map(url => {
      //const validEventId = formateEventUrl(url);
      return {
        EventLink: url,
        EventName: '',
        EventVenue: '',
        sections: [null],
        ticketType: [],
        price: [0],
        seatsAvailability: [],
        EventDate: null,
        active: false,
        hasFilter: false
      }
    });
    setEvents(prev => [...newEvent, ...prev]); // append at the start
    setHasfilter(false);
    const saveManual = JSON.parse(localStorage.getItem("manualEvents") || "[]");
    localStorage.setItem("manualEvents", JSON.stringify([...saveManual, ...newEvent]));

    setUrlInput('');
    processEventsInBackground(newEvent);
  }

  const resumeBackgroundProcessing = () => {
    if (resumeBackgroundRef.current) {
      const resume = resumeBackgroundRef.current;
      resumeBackgroundRef.current = null;
      resume();
    }
  };

  // open Filter Modal
  const openFilterModal = async (event) => {
    setSelectedEvent(event);
    setHasfilter(event.hasFilter);
    setShowModal(true);
  };
  // open filter
  const handleFilterApply = (eventLink, filterDetails) => {
    setEvents(prevEvents =>
      prevEvents.map(ev => {
        if (ev.EventLink === eventLink) {
          return {
            ...ev,
            hasFilter: true,
            filter: filterDetails,
            EventName: filterDetails.eventname,
            EventVenue: filterDetails.eventvenue,
            EventDate: filterDetails.eventdate,
            minPrice: filterDetails.priceFrom,
            maxPrice: filterDetails.priceTo,
            sections: formateSectionRange(filterDetails.sect),
            area: filterDetails.area.split(","),
            selectedType: filterDetails.ticketType,
            // ? filterDetails.sect.split(",").filter(s => s !== "")
            // : ev.sections
          }
        };
        return ev;
      }
      )
    );
    setShowModal(false);
    resumeBackgroundProcessing();
    //setSelectedEvent(null);
  };
  const formateUrl = (url) => {
    if (!url) return '';
    const match = url.match(/event\/([^/?]+)/);
    return match ? match[1] : "";
  }
  // const formateEventUrl = (url) => {
  //   if (!url) return null;
  //   const match = url.match(/^(https?:\/\/)?(www\.)?([^\/]+)\/event\/([A-Za-z0-9]+)(?=[/?#]|$)/i);
  //   if (!match) return null;
  //   return {hostname: match[3], eventId: match[4]};
  // };

  // formate section range
  // const formateSectionRange = (sectionString) => {
  //   if (!sectionString) return "";

  //   // Convert "110,201,202,203" → ["110","201","202","203"]
  //   const parts = sectionString
  //     .split(",")
  //     .map(s => s.trim())
  //     .filter(Boolean);

  //   if (!parts.length) return "";

  //   // Check if all entries are numeric
  //   const allNumeric = parts.every(sec => /^\d+$/.test(sec));

  //   if (allNumeric) {
  //     const nums = parts.map(Number).sort((a, b) => a - b);
  //     if (nums.length === 1) return String(nums[0]);
  //     return `${nums[0]} - ${nums[nums.length - 1]}`;
  //   }
  //   else {
  //     if (parts.length === 1) return parts[0];
  //     const first = parts[0];
  //     const last = parts[parts.length - 1];

  //     return `${first} - ${last}`;
  //   }
  // };

  const formateSectionRange = (sectionString) => {
    if (!sectionString) return "";

    const parts = sectionString
      .split(",")
      .map(s => s.trim())
      .filter(Boolean);

    if (parts.length === 0) return "";

    // Check if all parts are numeric
    const allNumeric = parts.every(p => !isNaN(p));

    if (allNumeric) {
      // Numeric: show first-last as range
      const first = parts[0];
      const last = parts[parts.length - 1];
      return first === last ? first : `${first} - ${last}`;
    } else {
      // const sorted = [...sectionString].sort((a, b) => {
      //   const numA = parseInt(a);
      //   const numB = parseInt(b);
      //   return numA - numB;
      // });
      // return `${sorted[0]} - ${sorted[sorted.length - 1]}`;

      // Non-numeric: join with first-last format
      const first = parts[0];
      const last = parts[parts.length - 1];
      return first === last
        ? first
        : `${first} - ${last}`;
    }
  };


  // const formateSectionRange = (sections) => {
  //   if (!sections || !sections.length || sections[0] === null) return;
  //   const sorted = [...sections].sort((a, b) => {
  //     const numA = parseInt(a);
  //     const numB = parseInt(b);
  //     return numA - numB;
  //   });
  //   return `${sorted[0]} - ${sorted[sorted.length - 1]}`;
  // }
  const formatePriceRange = (price) => {
    if (!price || !price.length || price[0] === 0) return '';
    return `$${Math.min(...price)} - $${Math.max(...price)}`
  }
  // const formateDateTime = (dateString) => {
  //   const parts = dateString.split(" ");
  //   const date = parts.slice(0,3).join(" ");
  //   const time = parts.slice(3).join(" ");
  //   return { date, time };
  // }

  // sorting data
  const handleSort = (columnKey) => {
    //console.log("Pressed sort on:", columnKey);
    let direction = 'asc';
    if (sortConfig.key === columnKey && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    const sortedEvents = [...events].sort((a, b) => {
      const aVal = a[columnKey];
      const bVal = b[columnKey];

      // price -> use min price as sort key
      if (columnKey === 'price') {
        const getMin = (arr) =>
          Array.isArray(arr) && arr.length ? Math.min(...arr) : Infinity;

        return direction === 'asc'
          ? getMin(a.price) - getMin(b.price)
          : getMin(b.price) - getMin(a.price);
      }

      // date -> convert to timestamp
      if (columnKey === 'EventDate') {
        const aTime = aVal ? new Date(aVal).getTime() : 0;
        const bTime = bVal ? new Date(bVal).getTime() : 0;

        return direction === 'asc' ? aTime - bTime : bTime - aTime;
      }

      // normalize strings (EventName, EventVenue, etc.)
      if (typeof aVal === 'string' && typeof bVal === 'string') {
        return direction === 'asc'
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
      }

      // fallback for other types
      if (aVal < bVal) return direction === 'asc' ? -1 : 1;
      if (aVal > bVal) return direction === 'asc' ? 1 : -1;
      return 0;
    });
    setEvents(sortedEvents);
    setSortConfig({ key: columnKey, direction })
  };

  const processEventsInBackground = async (eventsList) => {

    // server rate limiting, and extra SaveData calls). Use a small concurrency pool.
    const CONCURRENCY = 4;
    const queue = [...eventsList];
    // While an empty-price modal is open, all workers pause so no more events are applied
    let modalPause = Promise.resolve();
    let emptyPriceLock = Promise.resolve();

    const waitForUserFilter = () => {
      let release;
      modalPause = new Promise((resolve) => { release = resolve; });
      resumeBackgroundRef.current = () => {
        resumeBackgroundRef.current = null;
        release();
        modalPause = Promise.resolve();
      };
      return modalPause;
    };

    const worker = async () => {
      while (queue.length) {
        // Do not pull/apply more events while user is setting a filter in the modal
        await modalPause;

        const event = queue.shift();
        if (!event?.EventLink) continue;

        try {
          const res = await fetchEventDetails(event.EventLink);
          setLoading(true);
          await modalPause;

          const eventDetails = res?.d;

          if (!eventDetails || !eventDetails.sectiondict) {
            const placeHolder = {
              ...event,
              status: 'Event Not Found',
              active: false,
              hasFilter: false
            };
            setEvents(prev => prev.map(ev => ev.EventLink === event.EventLink ? placeHolder : ev));
            continue;
          }

          const sectiondict = eventDetails.sectiondict ? Object.values(eventDetails.sectiondict) : [];
          const priceList = Array.isArray(eventDetails.price) ? eventDetails.price : [];

          // No prices from backend — pause all workers, let user set filter, then resume
          if (!priceList.length) {
            const previousEmptyLock = emptyPriceLock;
            let releaseEmptyLock;
            emptyPriceLock = new Promise((resolve) => { releaseEmptyLock = resolve; });
            await previousEmptyLock;
            await modalPause;

            const enrichedEvent = {
              ...event,
              EventName: eventDetails.eventName || '',
              EventVenue: eventDetails.eventVenue || '',
              EventDate: eventDetails.eventDate || '',
              sections: sectiondict,
              price: priceList,
              minPrice: 0,
              maxPrice: 0,
              filter: null,
              hasFilter: false,
              active: false,
            };
            setEvents(prev =>
              prev.map(ev =>
                ev.EventLink === event.EventLink ? enrichedEvent : ev
              )
            );
            setLoading(false);
            openFilterModal(enrichedEvent);
            await waitForUserFilter();
            releaseEmptyLock();
            continue;
          }

          const minPrice = Math.min(...priceList);
          const maxPrice = Math.max(...priceList);

          const filterPayload = {
            eventurl: event.EventLink,
            ticketType: 'Any',
            priceFrom: minPrice,
            priceTo: maxPrice,
            price: priceList,
            sect: sectiondict.join(","),
            area: sectiondict.map((_, i) => i).join(","),
            Qty: '2',
            eventname: eventDetails.eventName || '',
            eventvenue: eventDetails.eventVenue || '',
            eventdate: eventDetails.eventDate || '',
            Minrange: "",
            Maxrange: ""
          };

          // UPDATE UI FIRST (fast)
          setEvents(prev =>
            prev.map(ev =>
              ev.EventLink === event.EventLink
                ? {
                  ...ev,
                  EventName: filterPayload.eventname,
                  EventVenue: filterPayload.eventvenue,
                  EventDate: filterPayload.eventdate,
                  sections: sectiondict,
                  minPrice,
                  maxPrice,
                  filter: filterPayload,
                  hasFilter: true,
                  active: true
                }
                : ev
            )
          );

          // SAVE FILTER IN BACKGROUND (do not block UI)
          const filterDatastr =
            `{eventurl:"${filterPayload.eventurl}",ticketType:"${filterPayload.ticketType}",priceFrom:"${filterPayload.priceFrom}",priceTo:"${filterPayload.priceTo}",price:"${filterPayload.price}",sect:"${filterPayload.sect}",area:"${filterPayload.area}",Qty:"${filterPayload.Qty}",eventname:"${filterPayload.eventname}",eventvenue:"${filterPayload.eventvenue}",eventdate:"${filterPayload.eventdate}",Minrange:"",Maxrange:""}`;

          // Intentionally not awaited
          saveFilterDetails(filterDatastr);
          populateEventData(); // Refresh data to get EventInfoID and other details saved by backend
        } catch (err) {
          console.log("EventDetails error:", err);
        }
      }
    };

    await Promise.all(Array.from({ length: CONCURRENCY }, worker));
    populateEventData();
    setLoading(false);
  };

  const getEventKey = (event) => {
    return event.EventInfoID ?? event.EventLink;
  }

  const isRowSelected = (event) => {
    const key = getEventKey(event);

    setSelectEvent(
      prev => prev.includes(key)
        ? prev.filter(id => id !== key)
        : [...prev, key]
    );
    setMessage('');
  }
  // const isRowSelected_forMonitor = (EventInfoId) => {
  //   setSelectEvent(
  //     prev => prev.includes(EventInfoId)
  //       ? prev.filter(id => id !== EventInfoId)
  //       : [...prev, EventInfoId]
  //   );
  //   setMessage('');
  // }
  const handleDelete = async () => {
    if (selectEvent.length === 0) {
      setMessage("Please select at least one event to delete.");
      return;
    }
    const idString = selectEvent.join(",");
    try {
      const response = await DeleteEvents(idString);
      if (response && response.d === null) {
        setEvents(prev => prev.filter(event => !selectEvent.includes(getEventKey(event))));
        setSelectEvent([]);
      } else if (response && response.d === 'success') {
        setSelectEvent([]);
        populateEventData();
        setMessage('');
      } else {
        setMessage('Try Again.');
      }
    }
    catch (error) {
      setMessage('Try Again.');
      console.log(error);
    }
  };

  const activate_Event = async () => {
    if (selectEvent.length === 0) {
      setMessage("Please select at least one event to activate.");
      return;
    }
    const idString = selectEvent.join(",");
    try {
      const response = await ActivateEvents(idString);
      if (response && response.d === 'success') {
        setSelectEvent([]);
        populateEventData();
        setMessage('');
      } else {
        setMessage('Apply Filter First.');

      }
    } catch (error) {
      setMessage('Apply Filter First.');
      console.log(error);
    }
  };

  const isAllSelected = () => {
    const selectedRows = currentData;
    if (selectedRows.length === 0) return false;
    return selectedRows.every(events => selectEvent.includes(events.EventInfoID));
  }
  const selectAll = () => {
    const inactiveEvents = currentData.map(event => event.EventInfoID);
    const allSelected = inactiveEvents.every(id => selectEvent.includes(id));
    setSelectEvent(prev => allSelected
      ? prev.filter(id => !inactiveEvents.includes(id))
      : [...new Set([...prev, ...inactiveEvents])]
    );
  }

  // HTML Template
  return (
    <main className='main-container'>
      <div className='container'>
        {/* <div className='main-title mt-3 mb-3'>
          <h4>DASHBOARD</h4>
        </div> */}
        <div className='row mt-5'>
          <div className='panel-container p-4'>
            <div className='d-flex pb-2 justify-content-between align-items-center'>
              <h5>Add Event URL</h5>
              <div className='d-flex gap-1 align-items-center'>
                <span className='d-flex align-items-center rounded-5 url-icon' style={{ padding: "6px" }}>
                  <FaLink />
                </span>

                <div className='user-credits'>
                  <p style={{ fontSize: "12px" }}>
                    URLs:
                    <span> {used} / {total}</span>
                  </p>
                </div>
                <button className='mx-2 btn btn-custom' onClick={handleAddUrl} disabled={!isValidUrl(urlInput)}> + Add All URL</button>

              </div>

            </div>
            <div className='gx-2 gy-2'>
              <div>
                <textarea className='form-control my-2' rows={4} name="url" id="url" placeholder='Enter your url here' value={urlInput} onChange={(e) => setUrlInput(e.target.value)}></textarea>
              </div>
              {/* <div className='text-end'>
                <button className='btn btn-custom' onClick={handleAddUrl} disabled={!isValidUrl(urlInput)}> + Add All URL</button>
              </div> */}
            </div>
          </div>
        </div>

        {/* <div className="row mt-4 d-flex justify-content-end" style={{ width: "400px" }}>
          <div className="panel-container">
            <span>
              <div className="input-group">
                <span className='input-group-text'><IoIosSearch style={{ fontSize: '20px' }} /></span>
                <input type="text" className="form-control my-input" placeholder='Search Event Name...' value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} id="" aria-describedby="emailHelp" required />
              </div>

            </span>

          </div>
        </div> */}

        <div className='row my-3'>
          <div className='panel-container table-responsive dashboard-table'>
            <div className='p-3 d-flex justify-content-between' >
              <div className='col-sm-4'>
                <div className="input-group">
                  <span className='input-group-text'><IoIosSearch style={{ fontSize: '20px' }} /></span>
                  <input type="text" className="form-control my-input search-input" placeholder='Search Event Name...' value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} id="" aria-describedby="emailHelp" required />
                </div>
              </div>

              <div className='d-flex  align-items-center'>
                {message && <span className='text-danger me-3'>{message}</span>}
                <button className='mx-2 btn btn-custom' onClick={activate_Event} > Activate Event</button>
                {/* disabled={selectEvent.length === 0} */}
                <button className='mx-2 btn btn-trash d-flex align-items-center' onClick={handleDelete} > <FaTrash className='bin me-1' />Delete Event</button>
              </div>


            </div>


            <table className='table align-middle text-center'>

              <thead className='mb-4'>
                <tr className='center table-head mb-6 p-2'>
                  <th colSpan={1}><input className='form-check-input' type="checkbox" checked={isAllSelected()} onChange={selectAll} /></th>
                  <th colSpan={2}>Event Name <LuArrowDownUp className='sort-arrow' onClick={() => handleSort('EventName')} /> </th>
                  <th colSpan={2}>Venue <LuArrowDownUp className='sort-arrow' onClick={() => handleSort('EventVenue')} /></th>
                  <th colSpan={1}>Date <LuArrowDownUp className='sort-arrow' onClick={() => handleSort('EventDate')} /></th>
                  <th colSpan={2} className='td-nowrap'>Price Range</th>
                  <th colSpan={2}>Section</th>
                  <th colSpan={2} className='td-nowrap'>Event ID</th>
                  <th colSpan={1}>Monitor</th>
                  <th colSpan={1}>Actions</th>
                </tr>
              </thead>

              <tbody>
                {  loading ? (
                    <tr>
                      <td colSpan={14} >
                        <div className='d-flex justify-content-center align-items-center' style={{ width: '100%' }}>
                          <ScreenLoading />
                        </div>
                      </td>
                    </tr>
                  ) : (
                  currentData.map((event, index) => (
                    <tr key={index} scope='row' className='dashboard-table'>
                      <td><input className='form-check-input' type="checkbox" checked={selectEvent.includes(getEventKey(event))} onChange={() => isRowSelected(event)} /> </td>
                      <td colSpan={2}>{event.EventName ? event.EventName : event.status}</td>
                      <td colSpan={2}>{event.EventVenue}</td>
                      <td colSpan={1}> {event.EventDate}
                        {/* {formateDateTime(event.EventDate).date} <br /> at {formateDateTime.apply(event.EventDate).time} */}
                      </td>
                      <td colSpan={2} className='td-nowrap'>
                        {/* {formatePriceRange(event.price)} */}
                        {event.filter ? `${event.minPrice ? event.minPrice : 0} - ${event.maxPrice ? event.maxPrice : 0}` : formatePriceRange(event.price)}
                      </td>
                      {/* {event.filter ? event.filter.sect.replace(/,$/, "") : */}
                      <td colSpan={2}> {event.filter ? formateSectionRange(event.filter.sect)  : formateSectionRange(event.section)}</td>
                      <td colSpan={2} > <img src={tmLogo} alt="loading" style={{ width: '30px' }} /> <br /><a href={event.EventLink} target="_blank" title={event.EventID}>{event.EventID || formateUrl(event.EventLink)}</a> </td>
                      <td><input className='form-check-input monitor' type="checkbox" checked={event.active} disabled /></td>
                      <td colSpan={1}>
                        <button type="button" onClick={() => openFilterModal(event)} className={`btn ${event.hasFilter ? "btn-edit" : "btn-filter"}`} >
                          {event.hasFilter ? "Edit" : "Filter"}
                        </button></td>
                    </tr>
                  )))
                }

              </tbody>
            </table>
            {/* onHide={() => setShowModal(false)} */}
            <EventFilterModal show={showModal} onHide={handleHide}
              eventMeta={selectedEvent} EventInfoID={selectedEvent.EventInfoId} hasFilter={hasFilter} onApplyFilter={handleFilterApply}>
              {/*  */}
            </ EventFilterModal>

            <Guide show={showGuide} onHide={() => setShowGuide(false)} />

            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              goToPage={goToPage}
              rowsPerPage={rowsPerPage}
              changeRowsPerPage={changeRowsPerPage}
            />

          </div>
        </div>

      </div>
    </main >
  )
}
